import { getOuterRange, InsertBetweenArray, getDataLocations } from '../Table'
import { CHANGE_TYPES } from './ChangeHistory'

const ACTIONS = {
  resetChanges: ({ disabled } = {}) => ({ title: 'Clear cell changes', icon: 'backspace', action: 'resetChanges', disabled: disabled }),
  addRowAbove: ({ disabled } = {}) => ({ title: 'Add row above', icon: 'add', action: 'addRowAbove', disabled: disabled }),
  deleteRow: ({ disabled } = {}) => ({ title: 'Delete row', icon: 'delete_forever', action: 'deleteRow', disabled: disabled }),
  undoLastChange: (props) => ({ title: 'Undo last row change', icon: 'undo', action: 'undoLastChangeAction', disabled: props.undoHistory.length == 0 }),
  redoLastChange: (props) => ({ title: 'Redo last row change', icon: 'redo', action: 'redoLastChangeAction', disabled: props.redoHistory.length == 0 }),
}

export default {
  addRowAbove: async function({ locationId, row, metadatum, logs, ignoreChangeHistory }) {
    if (!ignoreChangeHistory) {
      this.addChange({
        locationId,
        changeType: CHANGE_TYPES.addRowAbove,
        undo: () => {
          this.deleteRow({ locationId, ignoreChangeHistory: true })
        },
        redo: () => {
          this.addRowAbove({ locationId, row, metadatum, logs, ignoreChangeHistory: true })
        },
      })
    }

    let rowIndex = this.getRowIndex(locationId)
    let index = rowIndex * this.getMaxWidth()

    let newRow = row
    if (!newRow) {
      newRow = [...Array(this.getMaxWidth()).keys()]
        .map(() => ({
          data: {
            value: '',
            initialValue: '',
            // isNewRow: true,
          },
        }))
    }

    this.addNewRowMetadata({ rowIndex, metadatum })
    this.setCurrentData(InsertBetweenArray(this.getCurrentData(), index, newRow))

    this.updateDataLocations(this.getMaxWidth(), this.getIndex)
    let updatedLogLocations = this.getUpdatedLogLocations()
    this.updateLogs(updatedLogLocations)

    this.addLogs(logs)
  },
  undoLastChangeAction: function() {
    this.undoLastChange()
    return {}
  },
  redoLastChangeAction: function() {
    this.redoLastChange()
    return {}
  },
  getContextItems: function(contextName, location) {
    let items = this.ITEMS[contextName]
    let result

    let redoHistory = this.redoHistory
    let undoHistory = this.undoHistory

    let props = {
      undoHistory,
      redoHistory,
    }

    if (location) {
      props = { ...props, ...this.getCellMetadatum(location) || { index: location } }
      props.cellDatum = this.getLocationDatum(location)

      let datum = this.getLocationDatum(location)
      if (datum) props.hasChanges = datum.initialValue != datum.value
    }

    (result = items(props)
      .filter(item => !item.hidden))
    return result
  },
  deleteRow: async function({ locationId, ignoreChangeHistory }) {
    let rowIndex = this.getRowIndex(locationId)

    // Separate data
    let startIndex = rowIndex * this.getMaxWidth()
    let endIndex = (rowIndex + 1) * this.getMaxWidth()
    let { outer, inner } = getOuterRange(this.getCurrentData(), startIndex, endIndex)
    this.setCurrentData(outer)

    let metadatum = this.deleteRowMetadata(rowIndex)
    this.updateDataLocations(this.getMaxWidth(), this.getIndex)

    let removedLogLocations = getDataLocations(inner)
    let removedLogs = await this.removeLogs(removedLogLocations)

    if (!ignoreChangeHistory) {
      this.addChange({
        locationId,
        changeType: CHANGE_TYPES.deleteRow,
        undo: () => {
          this.addRowAbove({ locationId, metadatum, row: inner, logs: removedLogs, ignoreChangeHistory: true })
        },
        redo: () => {
          this.deleteRow({ locationId, ignoreChangeHistory: true })
        },
      })
    }

    let updatedLogLocations = this.getUpdatedLogLocations()
    this.updateLogs(updatedLogLocations)
  },
  ITEMS: {
    cell: (props) => [
      ACTIONS.resetChanges({ disabled: !props.hasChanges, hidden: false }),
      { divider: true },
      ACTIONS.addRowAbove(),
      ACTIONS.deleteRow({ disabled: props.isDeleted, hidden: !props.isNewRow }),
      ACTIONS.undoLastChange(props),
      ACTIONS.redoLastChange(props),
    ],
    rowHeader: (props) => [
      ACTIONS.addRowAbove(),
      ACTIONS.deleteRow({ disabled: props.isDeleted, hidden: !props.isNewRow }),
      ACTIONS.undoLastChange(props),
      ACTIONS.redoLastChange(props),
    ],
    columnHeader: () => [

    ],
  },
}